module.exports = __webpack_public_path__ + "img/1338807540.c5df6f06.jpg";